<template>
  <main class="home">
    <header class="header">
      <img
        class="is-hidden-desktop img-banner"
        src="../assets/images/banners/ventas_mobile.svg"
        alt=""
      />
      <div
        class="header__content-wrap column is-half-desktop is-offset-half-desktop"
      >
        <div class="header__content">
          <h2 class="color-primary mb-3">
            Facturación electrónica <br />
            nunca fue tan sencillo
          </h2>
          <p>
            Crea comprobantes de venta de la forma
            <br class="is-hidden-touch" />
            más fácil. Agiliza tu proceso de venta y
            <br class="is-hidden-touch" />comparte comprobantes co tus clientes
            en<br class="is-hidden-touch" />
            tan solo unos pasos.
          </p>
          <div class="header__actions">
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
            <a class="button is-rounded bg-disabled" @click="setVideoDemo"
              >Video Demo</a
            >
          </div>
        </div>
      </div>
    </header>
    <tab-modules></tab-modules>
    <section class="section no-padding--right no-padding--left">
      <div class="columns is-desktop section__video no-padding--right">
        <div class="ventas column">
          <img class="mal" src="../assets/images/venta_1.png" alt="" />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Contafácil empresa homologada<br class="is-hidden-touch" />
              como proveedor de servicios<br class="is-hidden-touch" />
              electrónicos SUNAT
            </h3>
            <p>
              Herramienta para las micro y<br class="is-hidden-touch" />
              pequeñas empresas que permite<br class="is-hidden-touch" />
              emisión de facturas, boletas, notas<br class="is-hidden-touch" />
              de créditos electrónicos.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded bg-primary ml-0"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="ventas column">
          <img src="../assets/images/venta_2.svg" alt="" />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Agiliza el proceso de tus ventas y<br class="is-hidden-touch" />
              mantente actualizado de su estado
            </h3>
            <p>
              Olvídate de los excels. Una nueva<br class="is-hidden-touch" />
              forma de monitorear los saldos<br class="is-hidden-touch" />
              pendientes y a favor de tus clientes.<br
                class="is-hidden-touch"
              />
              Agrega o anula pagos de tus<br class="is-hidden-touch" />
              operaciones diarias y ten<br class="is-hidden-touch" />
              seguimiento de las cuentas por<br class="is-hidden-touch" />
              cobrar de tu negocio.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded button-mr-0 bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--right  mar-top">
        <div class="ventas column column-50 column-offset-10">
          <img class="mal" src="../assets/images/venta_3.svg" alt="" />
        </div>
        <div class="video__text column is-two-fifths-desktop">
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Comparte los comprobantes de venta con tus clientes en segundos o
              envía recordatorios de sus deudas pendientes!
            </h3>
            <p>
              No más demoras ni dolores de cabeza en la entrega de comprobantes
              ni en el seguimiento de la venta. Contafácil envía automáticamente
              el documento al correo electrónico registrado una vez realizado el
              proceso de venta. Asimismo, imprime o descárgalo en caso sea
              solicitado por tu cliente.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded button-ml-0 bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
      <div class="columns is-desktop section__video no-padding--left mar-top">
        <div class="ventas column column-50">
          <img src="../assets/images/venta_4.png" alt="" />
        </div>
        <div
          class="video__text video__text--right column is-two-fifths-desktop"
        >
          <div class="text-wrap-aux">
            <h3 class="color-primary">
              Organiza el <br class="is-hidden-touch" />
              negocio a tu manera
            </h3>
            <p>
              Ahorra tiempo y ten la información<br class="is-hidden-touch" />
              en tan solo unos segundos.<br class="is-hidden-touch" />
              ContaFácil busca hacer eficiente y<br class="is-hidden-touch" />
              fácil la forma de tener acceso a los<br class="is-hidden-touch" />
              comprobantes de venta, documentos<br class="is-hidden-touch" />
              relacionados y reportes de venta de<br class="is-hidden-touch" />
              tus clientes.
            </p>
            <a
              rel="noopenner noreferer"
              class="button is-rounded button-mr-0 bg-primary"
              href="https://app.contafacil.pe/#!/registro"
              @click="emitGlobalTriggerGtag('prueba_gratis')"
              >Prueba Gratis</a
            >
          </div>
        </div>
      </div>
    </section>
    <section class="section section-factura px-2">
      <h2 class="color-primary">
        ContaFácil da soporte en cada paso.<br class="is-hidden-desktop" />
        Maneja tu
        <br class="is-hidden-touch" />
        negocio olvidándote del lado contable
      </h2>
      <img class="factura-img" src="../assets/images/venta_5.png" alt="" />
      <p class="m-center w-75 text-last-section-info factura-text">
        No te preocupes en buscar y ordenar los comprobantes de venta<br
          class="is-hidden-touch"
        />
        emitidos, de generar reportes de ventas a fin de mes, de cuadrar tu<br
          class="is-hidden-touch"
        />
        caja con los ingresos generados o de monitorear los movimientos de<br
          class="is-hidden-touch"
        />
        inventario. ContaFácil permite generar reportes de ventas y de tus<br
          class="is-hidden-touch"
        />
        clientes, y tener un estado actualizado del negocio para poder<br
          class="is-hidden-touch"
        />
        compartir reportes con tus asesores.
      </p>
      <a
        rel="noopenner noreferer"
        class="button is-rounded bg-primary"
        href="https://app.contafacil.pe/#!/registro"
        @click="emitGlobalTriggerGtag('prueba_gratis')"
        >Prueba Gratis</a
      >
    </section>
    <one-view></one-view>
  </main>
</template>

<script>
// @ is an alias to /src
import TabModules from "../components/TabModules.vue";
import OneView from "../components/OneView.vue";
import { EventBus } from "@/event-bus";
export default {
  name: "Ventas",
  components: {
    TabModules,
    OneView
  },
  methods: {
    emitGlobalTriggerGtag(type) {
      EventBus.$emit("triggerGtag", type);
    },
    setVideoDemo() {
      EventBus.$emit("triggerGtag", "video_demo");
      this.$modal.show("video-demo", {
        src: `<iframe width="560" height="315" src="https://www.youtube.com/embed/Nfy2VygrP7Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.header {
  // height: calc(100vh - 75px);
  // background-image: url("../assets/images/banners/ventas_mobile.svg");
  // background-repeat: no-repeat;
  // background-size: 100% auto;
  // background-attachment: local;
  // background-origin: border-box;
  .img-banner {
    width: 100%;
  }
  &__content-wrap {
    justify-content: flex-end;
    padding-bottom: 18%;
  }
  &__content {
    // height: 70%;
    margin-top: auto;
    p {
      width: 100%;
    }
  }
  @include tablet() {
    background-image: none;
    // height: fit-content;
    // max-height: 600px;
    // padding: 4em 0;
    &__content {
      background-color: transparent;
      // height: 50%;
      width: 100%;
      // padding: 1rem;
      // padding-top: 10rem;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1024px) {
    // height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/ventas.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
    &__content-wrap {
      // justify-content: center;
      padding-bottom: 0%;
    }
    &__content {
      background-color: transparent;
      height: 70%;
      width: 100%;
      p {
        width: 100%;
      }
    }
  }
  @media (min-width: 1200px) {
    // height: calc(100vh - 100px);
    background-image: url("../assets/images/banners/ventas.svg");
    background-repeat: no-repeat;
    // background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
  }
  @media (min-width: 1800px) {
    // height: calc(100vh - 120px);
    background-image: url("../assets/images/banners/ventas.svg");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-attachment: local;
    background-origin: border-box;
  }
}
.section-factura {
  margin: 1rem auto;
  // padding: 0 !important;
  h2 {
    font-size: 1rem;
    color: #00c3bd;
    margin: 2em auto;
  }
  img {
    width: 100%;
    height: auto;
  }
  .factura-text {
    width: 90%;
  }
  .button {
    // font-size: 1rem;
    // width: fit-content;
    // padding: 0.5em 2em;
    // margin: 1rem auto;
    // margin: .5em auto;
    padding: 0.5em 0.8em;
    border-radius: 25px !important;
    width: fit-content;
    min-width: 100px;
    font-weight: bold;
    font-size: 14px;
    line-height: 1;
    height: 2em;
  }
  @include tablet() {
    padding: 3rem !important;
    h2 {
      font-size: 1.5rem;
    }
    .factura-text {
      max-width: none !important;
    }
    img {
      width: 100%;
      height: auto;
    }
    .button {
      font-size: 1rem;
    }
    .factura-text {
      width: 100%;
      font-size: 1.5rem;
    }
  }
  @include laptop() {
    margin-top: 5rem;
    h2 {
      font-size: 1.2rem;
    }
    .factura-text {
      font-size: 1.2rem;
    }
    .factura-img {
      width: 100%;
      display: block;
      max-width: 810px;
      margin: 4rem auto;
    }
    .button {
      font-size: 1.2rem !important;
    }
  }
  @include desktop() {
    h2 {
      font-size: 1.4rem;
    }
    .factura-text {
      font-size: 1.4rem;
    }
    .factura-img {
      width: 100%;
      display: block;
      max-width: 810px;
      margin: 4rem auto;
    }
    .button {
      font-size: 1.2rem !important;
    }
  }
  @include desktop-medium() {
    h2 {
      font-size: 1.5rem;
    }
    .factura-text {
      font-size: 1.5rem;
    }
    .factura-img {
      width: 100%;
      display: block;
      max-width: 810px;
      margin: 4rem auto;
    }
    .button {
      font-size: 1.2rem !important;
    }
  }
  @include desktop-large() {
    h2 {
      font-size: 1.8rem;
    }
    .factura-img {
      width: 60%;
      display: block;
      max-width: 1500px;
      margin: 4rem auto;
    }
    .factura-text {
      font-size: 1.8rem;
    }
    .button {
      font-size: 1.2rem !important;
    }
  }
}
.section {
  // padding: 3rem;
  padding-top: 0px;
  .button {
    font-size: 16px;
    // font-weight: 500;
    // width: 100%;
  }
  h2 {
    font-weight: bold;
    // font-size: 3rem;
  }
  &__video {
    // min-height: 560px;
    width: 100%;
    margin: 1rem 0;
    // display: flex;
    // flex-flow: column nowrap;
    // justify-content: flex-start;
    // align-items: stretch;
    @include laptop() {
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;
      align-items: stretch;
      margin: 4em 0px;
    }
    @include desktop() {
      margin: 7em 0px;
    }
    // padding: 2rem;
    .video__text {
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: flex-start;
      // order: 2;
      &--right {
        text-align: center;
        align-items: flex-end;
      }
      h3 {
        letter-spacing: 0.05em;
        font-size: 16px;
        width: 100%;
        font-weight: bold;
        color: #00c3bd;
        margin: 2em auto;
      }
      p {
        width: 90%;
        font-size: 16px;
        letter-spacing: 0.025em;
        font-weight: 400;
        margin: 2em auto;
      }
      .button {
        margin: 1rem auto;
      }
      @include tablet() {
        text-align: center;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: center;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.05em;
          font-size: 1.5rem;
          width: 90%;
          font-weight: bold;
        }
        p {
          width: 90%;
          font-size: 1.5rem;
        }
        .button {
          max-width: 200px;
          font-size: 1.2rem;
          // margin: 1rem auto !important;
        }
      }
      @include laptop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        order: 0;
        &--right {
          text-align: right;
          align-items: flex-end;
          order: 1;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.3rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          width: 100%;
          font-size: 1.2rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.4rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          font-size: 1.4rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-medium() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.5rem;
          width: 100%;
          font-weight: bold;
        }
        p {
          // width: 90%;
          font-size: 1.5rem;
          letter-spacing: 0.075em;
          font-weight: 400;
        }
        .button {
          // margin-left: 0px;
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
      @include desktop-large() {
        text-align: left;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        &--right {
          text-align: right;
          align-items: flex-end;
        }
        h3 {
          letter-spacing: 0.075em;
          font-size: 1.8rem;
          font-weight: bold;
        }
        p {
          font-size: 1.8rem;
          letter-spacing: 0.075em;
          font-weight: 400;
          margin: 1.5em 0;
        }
        .button {
          width: fit-content;
          font-weight: bold;
          &-mr-0 {
            margin-right: 0;
          }
          &-ml-0 {
            margin-left: 0px;
          }
        }
      }
    }
    .video__player,
    .video-mini__player {
      order: 1;
      background-image: url("../assets/images/video-placeholder.png");
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      @include laptop() {
        // order: 0;
      }
    }
    .ventas {
      padding: 0px;
      // display: flex;
      order: 1;
      img {
        width: 100%;
        // height: auto;
      }
      @include tablet() {
        img {
          object-fit: contain;
          // width: 60%;
        }
      }
      @include laptop() {
        img {
          width: 100%;
        }
      }
    }
    .video-mini__player {
      height: 300px;
    }
    .video-mini__text {
      margin: 0 auto;
      margin-top: 3rem;
      width: 75%;
      h3 {
        letter-spacing: 0.075em;
        font-size: 2.55rem;
        width: 100%;
        font-weight: bold;
      }
      p {
        width: 90%;
        font-size: 2.4rem;
        letter-spacing: 0.075em;
        font-weight: 400;
      }
    }
    &:first-child {
      padding-top: 0px;
    }
    @include laptop() {
      margin: 4rem auto;
    }
  }
}
.text-wrap-aux {
  max-width: 480px;
}
</style>
